import React from 'react';
import PropTypes from 'prop-types';
import { Form, FormGroup } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import { isRequired } from '../../../../utils/validators';
import FormItem from '../../../common/forms/FormItem';
import FormFooter from '../../../common/forms/FormFooter';
import TextInput from '../../../common/forms/input/TextInput';
import Loader from '../../../common/Loader';

export const ItineraryFoodInvoiceSummaryForm = ({ handleSubmit, loading }) =>
  loading ? (
    <Loader />
  ) : (
    <Form onSubmit={handleSubmit}>
      <FormGroup row>
        <FormItem label="N° Resumen" required>
          <Field
            name="summaryNumber"
            component={TextInput}
            validate={[isRequired]}
          />
        </FormItem>
      </FormGroup>

      <FormFooter
        saveButtonText="Descargar Excel"
        saveButtonIcon="fa fa-file-excel-o"
        saveButtonColor="success"
      />
    </Form>
  );

ItineraryFoodInvoiceSummaryForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

ItineraryFoodInvoiceSummaryForm.defaultProps = {
  loading: false,
};

const formComponent = reduxForm({
  form: 'ItineraryFoodInvoiceSummaryForm',
})(ItineraryFoodInvoiceSummaryForm);

export default formComponent;
